// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.timeslot-wrapper:first-child{border-top:none}.timeslot-wrapper:last-child{border-bottom:none}.timeslot-wrapper{border-bottom:0.1rem solid silver}.timeslot-division{cursor:pointer;height:1.9rem}.timeslot-division.drop-is-over{background:#b8b8b8}\n", ""]);
// Exports
module.exports = exports;
